import React from 'react';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE } from './constants';
import parseTranslations from './parseTranslations';

export default function Internationalize({ children }) {
  // TODO: Replace with state when more languages are added
  const locale = DEFAULT_LOCALE;

  const localeMessages =
    locale === DEFAULT_LOCALE
      ? parseTranslations[DEFAULT_LOCALE]
      : {
          ...parseTranslations[DEFAULT_LOCALE],
          ...parseTranslations[locale]
        };

  return (
    <IntlProvider locale={locale} messages={localeMessages}>
      {children}
    </IntlProvider>
  );
}
